import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { FieldArray } from "formik";

import ResourcePanelActions from "./ResourcePanelActions.jsx";
import FormikAPIErrorMessage from "../../forms/formik/FormikAPIErrorMessage.jsx";

import { PANEL_STATES } from "../../../state/reducers/projectWizard/projectWizardConstants.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class ResourcePanel extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    resourceType: PropTypes.string.isRequired,
    blockComponent: PropTypes.object.isRequired,
    limits: PropTypes.object,
    availability: PropTypes.object.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    apiErrors: PropTypes.object,
    configCopyKey: PropTypes.string,
    configOptions: PropTypes.object,
    copyKey: PropTypes.string.isRequired,
    enableMultiples: PropTypes.bool.isRequired,

    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.resource_panel",
    enableMultiples: false,
    configOptions: {}
  };

  // -- RENDER -- //

  renderInstances = (instances, remaining, remove, replace) => {
    const {
      id,
      resourceType,
      blockComponent: BlockComponent,
      formikProps,
      apiErrors,
      configOptions,
      enableMultiples,
      configCopyKey,
      copyKey
    } = this.props;

    return instances.map((instance, index) => {
      const num = parseInt(instance.number);

      return (
        <BlockComponent
          id={`${id}[${index}]`}
          resourceType={resourceType}
          key={index}
          maxAvailableInstances={num + remaining}
          configOptions={configOptions}
          configCopyKey={configCopyKey}
          copyKey={copyKey}
          enableMultiples={enableMultiples}
          formikProps={formikProps}
          apiErrors={apiErrors}
          onRemove={() => remove(index)}
          onShowOrHideMultiples={newValue => {
            replace(index, newValue);
          }}
        />
      );
    });
  };

  calculateUsed(instances) {
    if (!instances || instances.length < 1) return 0;

    return instances.reduce((acc, item) => {
      const itemNumber = parseInt(item.number);
      const test = itemNumber > 1 ? acc + itemNumber : acc + 1;
      return test;
    }, 0);
  }

  renderPanelBody() {
    const {
      id,
      resourceType,
      blockComponent,
      limits,
      availability,
      configOptions,
      apiErrors,
      copyKey,
      copy
    } = this.props;

    return (
      <Fragment>
        <Header as="h3" attached="top" block>
          {copy(`${copyKey}.title`)}
        </Header>

        <FieldArray
          name={id}
          render={({ push, pop, remove, replace, form: { values } }) => {
            const instances = values[id] || [];
            const used = this.calculateUsed(instances);
            const remaining = limits.available - used;

            return (
              <Segment clearing={true} attached>
                <p>{copy(`${copyKey}.body`)}</p>

                <FormikAPIErrorMessage
                  name={id}
                  segment={true}
                  apiErrors={apiErrors}
                />

                {this.renderInstances(instances, remaining, remove, replace)}

                <ResourcePanelActions
                  limits={limits}
                  availability={availability}
                  configOptions={configOptions}
                  used={used}
                  doAdd={() => push(blockComponent.newInstance(resourceType))}
                  doRemove={() => pop()}
                  copyKey={copyKey}
                />
              </Segment>
            );
          }}
        />
      </Fragment>
    );
  }

  renderActive() {
    return this.renderPanelBody("body");
  }

  renderOptional() {
    return this.renderPanelBody("body_optional");
  }

  renderInactive() {
    return null;
  }

  render() {
    const { view } = this.props;

    switch (view) {
      case PANEL_STATES.ACTIVE:
        return this.renderActive();
      case PANEL_STATES.OPTIONAL:
        return this.renderOptional();
      default:
        return this.renderInactive();
    }
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ResourcePanel);
